// F1 Seasons Component
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TableChart } from '../charts';

const SeasonsComponent = ({ data }) => {
  // Transform season data to make years and drivers clickable
  const transformedSeasons = data?.seasonSummaries?.map(season => ({
    ...season,
    year: (
      <Link 
        to={`/f1/seasons/${season.year}`}
        className="theme-primary hover:theme-accent hover:underline font-medium"
      >
        {season.year}
      </Link>
    ),
    topDrivers: season.topDrivers && season.topDrivers.length > 0 ? (
      <div className="space-y-1">
        {season.topDrivers.map((driver, index) => (
          <div key={driver.driverId} className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <span className="text-xs theme-secondary font-medium w-4">
                {index + 1}
              </span>
              <Link 
                to={`/f1/drivers/${driver.driverId}`}
                className="theme-primary hover:theme-accent hover:underline text-sm"
              >
                {driver.driverName}
              </Link>
            </div>
            <span className="text-sm theme-secondary font-medium">{driver.points} pts</span>
          </div>
        ))}
      </div>
    ) : season.topDriverNames
  }));

  const renderSeasonTable = () => {
    if (!data || !data.seasonSummaries || data.seasonSummaries.length === 0) {
      return (
        <div className="theme-bg-secondary rounded-lg p-4">
          <p className="theme-secondary">No season data available</p>
        </div>
      );
    }

    return (
        <TableChart data={transformedSeasons || []}
          title="All Seasons"
          subtitle="Click on any year to view detailed Grand Prix results for that season, or click on driver names to view driver profiles."
          config={{
            columns: [
              { key: 'year', label: 'Season', width: 80 },
              { key: 'topDrivers', label: 'Top 3 Drivers & Points', width: 300 },
              { key: 'raceCount', label: 'Races', width: 80 }
            ],
            sortable: true,
            searchable: true,
            sortBy: 'year',
            sortDirection: 'desc',
            pagination: true,
            pageSize: 15,
            showHeader: true,
            rowHeight: 80,
            headerHeight: 40,
            showFooter: true,
            footerHeight: 40,
            
          }}
        />
    );
  };

  return (
    <>
      <div className="mt-8">
        {renderSeasonTable()}
      </div>

      <div className="mt-8">
        <h3 className="text-xl font-semibold theme-primary mb-4">Championship Information</h3>
        <div className="theme-bg-secondary rounded-lg p-4">
          <p className="theme-secondary">
            Season summaries showing the top 3 drivers and their championship points for each year. 
            Click on any season year to view detailed Grand Prix results, podium finishers, and race statistics.
          </p>
        </div>
      </div>
    </>
  );
};

export const seasonsConfig = {
  title: 'F1 Seasons',
  subtitle: 'Season summaries with top drivers, championship points, and race statistics',
  summary: ['Season overviews', 'Top drivers', 'Championship standings'],
  stats: [
    { 
      value: (data) => data?.seasonSummaries?.length || 0, 
      label: 'Seasons',
    },
    { 
      value: (data) => data?.seasonSummaries?.reduce((sum, season) => sum + season.raceCount, 0) || 0, 
      label: 'Total Races',
    },
    { 
      value: (data) => data?.seasonSummaries?.reduce((max, season) => Math.max(max, season.raceCount), 0) || 0, 
      label: 'Max Races/Season',
    },
    { 
      value: (data) => data?.seasonSummaries?.filter(season => season.topDrivers && season.topDrivers.length >= 3)?.length || 0, 
      label: 'Complete Seasons',
    }
  ],
  component: SeasonsComponent
};

export default SeasonsComponent;
